module.exports = __webpack_public_path__ + "img/giftwrap.7ad3b98.png";